// Shared configuration - same across all environments
export const sharedConfig = {
  product: 'outlook',
  cdn: 'https://cdn-maximizer-dev.azureedge.net',
  httpConfiguration: {
    timeout: 15000,
    retryAmount: 3,
  },
  graphApiConfig: {
    scopes: ['Mail.ReadWrite', 'User.Read'],
    uri: 'https://graph.microsoft.com/v1.0',
  },
  minLogLevelFeatureFlag: 'integration-o365-min-log-level',
};

export const syncSharedConfig = {
  tenantId: 'common',
  scopes: [
    'https://graph.microsoft.com/Contacts.ReadWrite',
    'https://graph.microsoft.com/User.Read',
    'https://graph.microsoft.com/MailboxSettings.Read',
    'https://graph.microsoft.com/Calendars.ReadWrite',
    'https://graph.microsoft.com/Tasks.ReadWrite',
    'https://graph.microsoft.com/Mail.Read',
    'offline_access',
  ],
};
